import React from 'react'
import styled from 'styled-components'
import { Successimg } from 'src/assets'
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 90vh;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  p {
    width: 262px;
    font-weight: 300;
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 30px;
    letter-spacing: -0.01em;
    color: ${({ theme }) => theme.colors.gray};
    text-align: center;
    margin-top: -15px;
  }
  h1 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-size: ${({ theme }) => theme.fontSize.xx1};
    letter-spacing: -0.01em;
    color: ${({ theme }) => theme.colors.dark};
  }
  .full {
    width: auto;
  }
  .span {
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.successGreen};
    font-weight: 700;
  }
  .desc {
    text-decoration: uppercase;
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  .fulls {
    font-weight: bold;
    font-size: ${({ theme }) => theme.fontSize.xx2};
    line-height: 30px;
    letter-spacing: -0.01em;
    color: ${({ theme }) => theme.colors.dark};
  }
`
const Success = () => {
  return (
    <Wrapper>
      <img src={Successimg} alt="" />
      <h1>Congratulations!!!</h1>
      <p>Your quicksave was successful and you are doing very well!</p>
    </Wrapper>
  )
}

const SuccessFull = () => {
  return (
    <Wrapper>
      <img src={Successimg} alt="" />
      <h1>Successful!</h1>
      <p>Your withdrawal is complete.</p>
    </Wrapper>
  )
}
const CardSuccessFull = () => {
  return (
    <Wrapper>
      <img src={Successimg} alt="" />
      <h1>Successful!</h1>
      <p className="full">Your card has been added successfully.</p>
    </Wrapper>
  )
}
const TargetSuccessFull = () => {
  return (
    <Wrapper>
      <img src={Successimg} alt="" />
      <h1>Success!</h1>
      <p className="full">
        Your target <span className="span">HOUSE BILLS</span> has been created
      </p>
    </Wrapper>
  )
}
const TransferSuccessFull = () => {
  return (
    <Wrapper>
      <img src={Successimg} alt="" />
      <h1>Success!</h1>
      <p className="full">Your transfer is complete.</p>
    </Wrapper>
  )
}
const InvestmentSuccessFull = () => {
  return (
    <Wrapper>
      <img src={Successimg} alt="" />
      <h1>Congratulations!</h1>
      <p className="full">
        Your investment is complete. An update will follow shortly.
      </p>
    </Wrapper>
  )
}

const CollaboSuccessFull = () => {
  return (
    <Wrapper>
      <img src={Successimg} alt="" />
      <h1>Success!</h1>
      <p className="full">
        prolifiqmexie@gmail.com has been added to{' '}
        <span className="desc">GRADUATION</span>
      </p>
    </Wrapper>
  )
}

const TokenSent = () => {
  return (
    <Wrapper>
      <img src={Successimg} alt="" />
      <h1>Token sent!</h1>
      <p className="full">
        A verification token has been sent to your mail.
        <br /> Please enter it to complete your update.
      </p>
    </Wrapper>
  )
}
const TokenSentNumber = () => {
  return (
    <Wrapper>
      <img src={Successimg} alt="" />
      <h1>Token sent!</h1>
      <p className="full">
        Your OTP has been sent via SMS to *******8080. <br />
        Please enter it to complete your action.
      </p>
    </Wrapper>
  )
}
const ShowwBvn = () => {
  return (
    <Wrapper>
      <h2 className="fulls">Your BVN is 123456780</h2>
    </Wrapper>
  )
}

export {
  Success,
  TokenSent,
  ShowwBvn,
  TokenSentNumber,
  SuccessFull,
  CardSuccessFull,
  TargetSuccessFull,
  TransferSuccessFull,
  InvestmentSuccessFull,
  CollaboSuccessFull,
}
